import recommendedItemQueries from '@apis/queries/recommendedItemQueries';
import { useQuery } from '@tanstack/react-query';

function useMainRecommendedItems() {
    const { data, isFetching } = useQuery(recommendedItemQueries.main());
    return { data, isFetching };
}

export default useMainRecommendedItems;
